import React from "react";

export default function IconBoxStyle5({ title, iconUrl }) {
  return (
    <div className="cs_brand_card">
      {/* Image */}
      <div className="cs_brand_img_wrap">
        {iconUrl ? (
          <img src={iconUrl} alt={title} />
        ) : (
          <div className="cs_brand_placeholder">
            {title?.slice(0, 2)}
          </div>
        )}
      </div>
    </div>
  );
}